// Ausschließlich ausdrückliche BIS-Formularaktionen; kein Onsite-SDK oder Tracking.
export function subscriptionPayloads(email, variantId, listId, newsletter) {
  const profile = { data: { type: 'profile', attributes: { email } } };
  const requests = [];
  if (newsletter) {
    requests.push({
      path: 'subscriptions',
      body: { data: {
        type: 'subscription',
        attributes: { profile },
        relationships: { list: { data: { type: 'list', id: listId } } },
      } },
    });
  }
  requests.push({
    path: 'back-in-stock-subscriptions',
    body: { data: {
      type: 'back-in-stock-subscription',
      attributes: { profile, channels: ['EMAIL'] },
      relationships: { variant: { data: {
        type: 'catalog-variant', id: `$shopify:::$default:::${variantId}`,
      } } },
    } },
  });
  return requests;
}

export async function submitSubscription(companyId, requests, send = fetch) {
  for (const request of requests) {
    const response = await send(`https://a.klaviyo.com/client/${request.path}?company_id=${encodeURIComponent(companyId)}`, {
      method: 'POST',
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
      body: JSON.stringify(request.body),
    });
    if (!response.ok) throw new Error('Back-in-stock request was not accepted');
  }
}

class ElliBackInStock extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    this.form = this.querySelector('[data-bis-form]');
    this.trigger = this.querySelector('[data-bis-open]');
    this.error = this.querySelector('[data-bis-error]');
    this.success = this.querySelector('[data-bis-success]');
    this.trigger.addEventListener('click', () => {
      this.form.hidden = false;
      this.success.hidden = true;
      this.error.hidden = true;
      this.dialog.showModal();
      this.form.elements.email.focus();
    }, { signal });
    this.querySelector('[data-bis-close]').addEventListener('click', () => this.dialog.close(), { signal });
    this.form.addEventListener('submit', this.onSubmit, { signal });
    this.closest('.shopify-section')?.addEventListener('shopify:product:select', this.onProductSelect, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onProductSelect = async (event) => {
    if (event.target.closest('product-card')) return;
    const generation = this.generation = (this.generation || 0) + 1;
    this.hidden = true;
    this.dialog.close();
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.generation) return;
      const variant = detail?.resource;
      this.dataset.variantId = variant?.id || '';
      this.dataset.available = String(variant?.available !== false);
      this.hidden = !variant?.id || variant.available !== false;
      const title = detail?.html?.querySelector('elli-back-in-stock [data-bis-title]')?.textContent;
      if (title) this.querySelector('[data-bis-title]').textContent = title;
    } catch {
      // Bei abgebrochener Variantenauswahl keinen alten Varianten-Anker anbieten.
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.submitting || !this.form.reportValidity() || this.dataset.available !== 'false') return;
    const variantId = this.dataset.variantId;
    if (!/^\d+$/.test(variantId || '')) return;
    this.submitting = true;
    const button = this.form.querySelector('[type="submit"]');
    button.disabled = true;
    this.form.setAttribute('aria-busy', 'true');
    this.error.hidden = true;
    try {
      await submitSubscription(this.dataset.companyId, subscriptionPayloads(
        this.form.elements.email.value.trim(), variantId, this.dataset.listId, this.form.elements.newsletter.checked,
      ));
      if (!this.isConnected || this.dataset.variantId !== variantId) return;
      this.form.hidden = true;
      this.success.hidden = false;
      this.success.focus();
    } catch {
      if (!this.isConnected || this.dataset.variantId !== variantId) return;
      this.error.textContent = this.dataset.error;
      this.error.hidden = false;
    } finally {
      this.submitting = false;
      button.disabled = false;
      this.form.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('elli-back-in-stock')) customElements.define('elli-back-in-stock', ElliBackInStock);
